import css from "styled-jsx/css";
import { toRadians } from "utils/math";

export const triangleHeightFactor = Math.sin(toRadians(8));

export const componentStyles = css`
  .base-layout-segment-component {
    .triangle {
      position: absolute;
      z-index: 2;
      &.top {
        width: 0;
        height: 0;
        border-right: 100vw solid transparent;
        margin-top: ${`-${100 * triangleHeightFactor}vw`};
      }
      &.bottom {
        width: 0;
        height: 0;
        border-left: 100vw solid transparent;
      }
    }
  }
`;
